import { Component, OnInit, Input } from '@angular/core';
import { StatusService } from 'app/services/status.service';
import { CountryService } from 'app/services/country.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { PlaceService } from 'app/services/place.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-manage-country-places',
  templateUrl: './manage-country-places.component.html',
  styleUrls: ['./manage-country-places.component.css']
})
export class ManageCountryPlacesComponent implements OnInit {

  removeRef: any;
  page = 1;
  showNum: number = 10;
  popoverTitle = 'Delete Place';
  popoverMessage = 'Are you sure you want to delete Place?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  countryPlaceFlag: boolean = false;
  public isLoading = false;
  isEmpty: boolean = false;
  message = "Loading Places...";
  placesList: any = [];
  selectCountry: any = Object();
  lblHeading = "Places";

  //Filter settings
  public countryProvinces: any = [];
  public selectedProvince = 0;
  public filterQuery: string = "";
  public placesTempForFilt: any = [];


  @Input() list: any;

  isRemove: boolean = false;
  countryId: any = "";
  provinceList: any = [];
  placeList: any = [];
  constructor(private statusService: StatusService,
    private countryService: CountryService, private route: ActivatedRoute,
     public utility: UtilityServiceService, private toastr: ToastrService,
    private placeService: PlaceService, private router: Router) { }

  ngOnInit() {
    let id: any = this.route.params['_value'].type;
    this.list = { id: atob(id) };
    this.utility.page = 1;
    this.countryId = btoa(this.list.id);
    //this.getPlaces();
    this.loadCountryDetails(this.list)
    this.getProvinces();
    this.getCountries();

  }
  getCountries() {
    this.countryService.listAllCountries().subscribe((res:any) => {
      this.list = res.find(x => x.id == this.list.id);
      this.selectCountry = this.list;
    })
  }
  loadCountryDetails(list) {
    this.lblHeading = "Places";
    this.countryPlaceFlag = true;
    this.placeService.getAllCountryPlaces(list.id).subscribe(res => {
      //console.log(res);
      this.placesList = [];
      this.placesList = res;
      if (this.utility.flags.flagSO != 2) {
        this.utility.onSort(5);
      }
    });
  }
  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Place <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeandig(false);
    this.isRemove = true;
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = (change) ? 'Places' : 'Delete Place';
  }
  navigate(path) {
    //console.log(this.selectCountry);
    path = path + "/" + btoa(this.selectCountry.id);
    this.router.navigate([path]);
  }
  navigateToEdit(path, list) {
    path = path + "/" + btoa(this.list.id) + "/" + btoa(list.id);
    this.router.navigate([path]);
  }
  onDelete(id: any) {
    this.placeService.deletePlace(id).subscribe(res => {
      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Status', message: `Status ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastr.success(`Place ${this.removeRef.code} deleted.`, 'Delete Place');
      if (res != null) {
        this.onNo();
        this.loadCountryDetails(this.list);
      }
      this.onChangeHeandig();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Status', message: `Status ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastr.error(`Place ${this.removeRef.code} was not deleted.`, 'Delete Place');
    });

  }
  getProvinces() {
    this.countryService.listAllProvinces().subscribe(res => {
      this.provinceList = res;
      this.getPlaces();
    })
  }
  getPlaces() {
    //console.log(this.list);
    this.placeService.getAllCountryPlaces(this.list.id).subscribe(res => {
      this.placeList = res;
      this.placesTempForFilt = res;
      this.placeList.forEach(element => {
        if (this.countryProvinces.find(x => x.id == element.province_id) == null)
          this.countryProvinces.push({ id: element.province_id, description: this.getprovinceDesc(element.province_id) });
      });
    })
  }
  getPlaceDesc(placeId) {
    if (placeId != null) {
      let list = this.placeList.find(({ id }) => +id === placeId);
      if (list != null) {
        return list.name;
      } else {
        return placeId;
      }
    }
  }
  getprovinceDesc(provinceId) {
    if (provinceId != null) {
      let list = this.provinceList.find(({ id }) => +id === provinceId);
      if (list != null) {
        return list.description;
      } else {
        return provinceId;
      }
    }
  }
  onReset(borderPostCheck, taxiRankCheck, terminusCheck) {
    this.utility.page = 1;
    this.selectedProvince = 0;
    this.filterQuery = "";
    borderPostCheck.checked = false;
    taxiRankCheck.checked = false;
    terminusCheck.checked = false;
    this.placesList = this.placesTempForFilt;
  }
  onSearch(borderPostCheck, taxiRankCheck, terminusCheck) {
    this.utility.page = 1;
    let filterWithList = [];

    if (this.selectedProvince == 0) {
      filterWithList = this.placesTempForFilt;
    }
    else {
      filterWithList = this.placeList.filter(x => x.province_id == this.selectedProvince);
    }

    if (borderPostCheck.checked && taxiRankCheck.checked && terminusCheck.checked) {
      this.placesList = filterWithList.filter(x => x.name.toLowerCase().includes(this.filterQuery.toLowerCase()) && x.is_border_post && x.is_taxi_rank && x.is_terminus);
    }
    else if (borderPostCheck.checked && taxiRankCheck.checked) {
      this.placesList = filterWithList.filter(x => x.name.toLowerCase().includes(this.filterQuery.toLowerCase()) && x.is_border_post && x.is_taxi_rank);
    }
    else if (borderPostCheck.checked && terminusCheck.checked) {
      this.placesList = filterWithList.filter(x => x.name.toLowerCase().includes(this.filterQuery.toLowerCase()) && x.is_border_post && x.is_terminus);
    }
    else if (taxiRankCheck.checked && terminusCheck.checked) {
      this.placesList = filterWithList.filter(x => x.name.toLowerCase().includes(this.filterQuery.toLowerCase()) && x.is_taxi_rank && x.is_terminus);
    }
    else if (borderPostCheck.checked) {
      this.placesList = filterWithList.filter(x => x.name.toLowerCase().includes(this.filterQuery.toLowerCase()) && x.is_border_post);
    }
    else if (taxiRankCheck.checked) {
      this.placesList = filterWithList.filter(x => x.name.toLowerCase().includes(this.filterQuery.toLowerCase()) && x.is_taxi_rank);
    }
    else if (terminusCheck.checked) {
      this.placesList = filterWithList.filter(x => x.name.toLowerCase().includes(this.filterQuery.toLowerCase()) && x.is_terminus);
    }
    else {
      this.placesList = filterWithList.filter(x => x.name.toLowerCase().includes(this.filterQuery.toLowerCase()));
    }

  }
}
